<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-deploy-associations`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 3a6 6 0 012 11.658v1.497L34.392 21v11.761l1.64 1.024a6 6 0 11-2.636 3.07l-2.729-1.704L24 39l-6.668-3.849-2.727 1.704a6 6 0 11-2.635-3.07l1.637-1.023V21L22 16.155v-1.496A6 6 0 0124 3zm15 34a2 2 0 100 4 2 2 0 000-4zM9 37a2 2 0 100 4 2 2 0 000-4zm15-17.381l-6.392 3.69v7.382L24 34.38l6.392-3.69v-7.382L24 19.62zM24 7a2 2 0 100 4 2 2 0 000-4z"/></svg>
</template>
<script>

export default {
  name: 'IconDeployAssociations',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
